import React from "react";
import Header from "../components/Header";
import useFetchData from "../services/useFetchData";
import { apiGetAllPublishedRooms } from "../services/apiService";
import { helpVideos } from "../data/helpVideosData";
import { Link } from "react-router-dom";

const Help = () => {
  // const { data, isLoading, error, payload } = useFetchData(getUserById, 1, {
  //   name: "Smelly",
  // });

  // const { data, isLoading, error } = useFetchData(apiGetAllPublishedRooms);
  // console.log(data);

  return (
    <>
      <section id="header" className="w-screen">
        <Header />
      </section>
      <section
        id="help"
        className="fixed left-0 right-0 mt-20  h-screen  overflow-hidden overflow-y-scroll"
      >
        <div className="flex justify-center text-3xl mt-10">Help Page</div>
        <div className="grid  justify-items-center text-justify px-8 mt-5">
          <div className="max-w-[500px]">
            The following videos explain how to use each snappily feature.
            However, if you still have quetions feel free to email us at:
          </div>
          <a
            className="px-1 text-blue-500 hover:text-blue-700 cursor-pointer mt-3"
            href="mailto:support@snappily.io"
          >
            support@snappily.io
          </a>
        </div>
        <div className="flex justify-center text-2xl mt-0 mb-60">
          <ul className="p-5">
            {helpVideos.map((item, index) => {
              return (
                <a
                  key={item.id}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer"
                >
                  <li
                    className="grid grid-cols-3 content-center h-28 border-gray-400 
                  hover:border-snappily-orange border-1 hover:border-2 rounded-md p-3 mt-2"
                  >
                    <div
                      className="flex justify-center items-center max-h-20 max-w-40
                   bg-black rounded-md"
                    >
                      <img
                        src={item.image}
                        alt={`A video of ${item.title}`}
                        className="max-h-20 px-1"
                      />
                    </div>
                    <div className="flex col-span-2 col-start-2 text-lg pl-5 sm:pl-3">
                      {item.title}
                    </div>
                  </li>
                </a>
              );
            })}
          </ul>
        </div>
      </section>
    </>
  );
};

export default Help;
